import { useService } from 'react-reservice';

import { copyTradeSectionSettingsService } from '@aqx-core/common/services/copy-trade/section-settings/service';

export const useAvailableStrategySections = () => {
  return useService(copyTradeSectionSettingsService, (context) => context.availableStrategySections);
};

export const useAllStrategySections = () => {
  return useService(copyTradeSectionSettingsService, (context) => context.allStrategySections);
};

export const useOriginalStrategySections = () => {
  return useService(copyTradeSectionSettingsService, (context) => context.originalStrategySections);
};

export const useEditingStrategySections = () => {
  return useService(copyTradeSectionSettingsService, (context) => context.editingStrategySections);
};

export const useIsStrategySectionsDirty = () => {
  return useService(copyTradeSectionSettingsService, (context) => context.isStrategySectionsDirty);
};

export const useIsResetDefaultButtonDisabled = () => {
  return useService(copyTradeSectionSettingsService, (context) => context.isResetDefaultButtonDisabled);
};

export const useIsStrategySectionsLoading = () => {
  return useService(copyTradeSectionSettingsService, (context) => context.isStrategySectionsLoading);
};
